// English source strings for the integration module catalogue (decision D19, slice 1) and its panel.
// Merged into `en`; pt-BR lives in pt-BR-modules.ts (complete, checked by the type).
export const enModules = {
  "integrations.tab.catalog": "Catalog",
  "modules.subtitle": "Centralize the services your agents and projects use: messaging channels, AI providers, payments and automations.",
  "modules.search": "Search integrations",
  "modules.searchPlaceholder": "Search integration…",
  "modules.filters": "Filter by category",
  "modules.filter.all": "All",
  "modules.category.canal": "Communication channel",
  "modules.category.ia": "Artificial intelligence",
  "modules.category.pagamento": "Payment gateway",
  "modules.category.automacao": "Automation",
  "modules.category.dados": "Data",
  "modules.category.infra": "Infrastructure",
  "modules.category.outros": "Other",
  "modules.comingSoon": "Coming soon",
  "modules.comingSoonHint": "Not available yet",
  "modules.instancesOne": "1 instance",
  "modules.instancesMany": "{n} instances",
  "modules.versionTitle": "Module {module} · version {version}",
  "modules.loading": "Loading the integration catalog",
  "modules.loadFailed": "Could not load the integration catalog",
  "modules.emptyTitle": "No integrations in the catalog yet",
  "modules.emptyBody": "No module is installed in this release. Nothing here is simulated.",
  "modules.noMatchTitle": "No integration matches your search",
  "modules.noMatchBody": "Try another term or choose “All” in the filters.",
  "modules.clearFilters": "Clear search and filters",
  "modules.resultsCount": "{n} integrations shown",
  "modules.detail.facts": "Module details",
  "modules.detail.module": "Module",
  "modules.detail.version": "Version",
  "modules.detail.maturity": "Maturity",
  "modules.detail.scope": "Scope",
  "modules.detail.category": "Category",
  "modules.detail.capabilities": "Capabilities",
  "modules.detail.operations": "Operations",
  "modules.detail.none": "None declared",
  "modules.detail.unknown": "Not declared",
  "modules.maturity.experimental": "Experimental",
  "modules.maturity.beta": "Beta",
  "modules.maturity.stable": "Stable",
  "modules.maturity.deprecated": "Deprecated",
  "modules.scope.instalacao": "Whole installation",
  "modules.scope.conta": "Per account (organization)",
  "modules.scope.conexao": "Per connection",
  "modules.state.draft": "Draft",
  "modules.state.active": "Active",
  "modules.state.disabled": "Inactive",
  "modules.state.error": "Error",
  "modules.action.label": "{action}: {name}",
  "modules.panel.version": "Version {version}",
  "modules.panel.standalone": "Works on its own: doesn't depend on another integration.",
  "modules.panel.dependsOn": "Depends on {list}.",
  "modules.panel.needsRole": "at least {min} {role}",
  "modules.panel.role.provedor-de-ia": "AI provider",
  "modules.panel.about": "About this integration",
  "modules.panel.accountsIntro": "Connect one or more {name} accounts and give each one a name your team recognizes.",
  "modules.panel.vaultNote": "The key is stored in the system vault and never comes back to the screen.",
  "modules.panel.notExecutable.channel_module": "This channel is connected by whoever runs this installation; it can't be set up from this panel yet.",
  "modules.panel.notExecutable.host_executed_card": "This card is set up by the system itself and doesn't use an account of its own.",
  "modules.panel.notExecutable.other": "This integration can't be connected from this panel yet.",
  "modules.panel.configLoadFailed": "Could not load this integration's settings",
  "modules.panel.accounts": "Accounts",
  "modules.panel.accountsEmptyTitle": "No {name} account yet",
  "modules.panel.accountsEmptyBody": "Add the first account below to start using this integration.",
  "modules.panel.readOnly": "Only administrators add and change accounts.",
  "modules.panel.loadFailed": "Could not load the accounts",
  "modules.panel.keyStored": "Key stored",
  "modules.panel.keyStoredHint": "Key stored ({hint})",
  "modules.panel.keyMissing": "No key yet",
  "modules.panel.keyRevoked": "Key revoked",
  "modules.panel.lastTestOk": "Last test passed: {summary}",
  "modules.panel.lastTestFailed": "Last test failed: {summary}",
  "modules.panel.neverTested": "Not tested yet",
  "modules.panel.edit": "Edit",
  "modules.panel.test": "Test",
  "modules.panel.activate": "Activate",
  "modules.panel.deactivate": "Deactivate",
  "modules.panel.delete": "Delete",
  "modules.panel.activationUnavailable": "Activation isn't available for this integration here yet.",
  "modules.panel.activationNeedsTest": "Pass the test to activate this account.",
  "modules.panel.activateTitle": "Activate “{name}”?",
  "modules.panel.activateBody": "From now on, agents and projects can make real calls to {provider} with this account. You can deactivate it at any time.",
  "modules.panel.activated": "Account “{name}” activated.",
  "modules.panel.deactivated": "Account “{name}” deactivated.",
  "modules.panel.deleteTitle": "Delete the account “{name}”?",
  "modules.panel.deleteBody": "The key is erased from the system vault and the account disappears from every list. Its test and usage history is kept for audit. This can't be undone.",
  "modules.panel.deleteConfirm": "Delete account",
  "modules.panel.deleted": "Account “{name}” deleted.",
  "modules.panel.deleteRefused.instance_active": "Deactivate this account before deleting it.",
  "modules.panel.deleteRefused.instance_in_use": "This account is used by a model connection or by another integration. Remove that link first.",
  "modules.panel.testPassed": "Test passed: {summary}",
  "modules.panel.testFailed": "Test failed: {summary}",
  "modules.panel.testRefused": "The test could not run.",
  "modules.panel.addTitle": "Add an account for {name}",
  "modules.panel.addBody": "Give it a name to recognize it later (for example, the team or the project) and paste the key. The system tests the key when you save.",
  "modules.panel.addBodyNoSecret": "Give it a name to recognize it later and fill in the settings. The system tests them when you save.",
  "modules.panel.editTitle": "Edit “{name}”",
  "modules.panel.editBody": "Change the name or the settings. Leave the key blank to keep the current one.",
  "modules.panel.accountName": "Account name",
  "modules.panel.accountNameHint": "Shown wherever someone picks this account: agents, projects and models.",
  "modules.panel.accountNamePlaceholder": "e.g. {name} — company",
  "modules.panel.keepKey": "Leave blank to keep the current key.",
  "modules.panel.nameRequired": "Give the account a name.",
  "modules.panel.fieldRequired": "Fill in “{label}”.",
  "modules.panel.tooShort": "Must have at least {n} characters.",
  "modules.panel.tooLong": "Must have at most {n} characters.",
  "modules.panel.optional": "optional",
  "modules.panel.choose": "Choose…",
  "modules.panel.yes": "Yes",
  "modules.panel.no": "No",
  "modules.panel.saveAndTest": "Save and test",
  "modules.panel.save": "Save",
  "modules.panel.connected": "Account “{name}” connected. {summary}",
  "modules.panel.saved": "Account “{name}” saved.",
  "modules.panel.keyRefused": "Account “{name}” saved, but the test failed: {summary}",
  "modules.panel.savedTestBlocked": "Account “{name}” saved, but the test could not run.",
  "modules.panel.checkFields": "Check the highlighted fields.",
  "modules.panel.whereKey": "Where do I find the key?",
  "modules.panel.help.1": "Sign in to {name} with the company account.",
  "modules.panel.help.2": "Open the API keys area and create a key just for this system.",
  "modules.panel.help.3": "Copy the key right away (many providers show it only once) and paste it above.",
  "modules.panel.help.4": "Make sure the account has credit or an active plan: without it, calls are refused.",
  "modules.panel.technical": "Technical details",
  "modules.panel.versionInUse": "Version in use: {version}",
  "modules.panel.copyDiagnostic": "Copy diagnostic",
  "modules.panel.diagnosticCopied": "Diagnostic copied (no keys included).",
  "modules.panel.copyFailed": "Could not copy: the browser blocked the clipboard.",
} as const;
